<template>
  <div class="position-relative">
    <div :id="fn_isNull(id) ? 'map' : id" class="w-100">
      <div class="marker-custom"></div>
      <!--      <div class="input-group mb-3 input-search" >-->
      <!--      <input type="text" class="form-control" aria-label="Text input with checkbox">-->
      <!--      </div>-->
    </div>
  </div>
</template>
<style scoped>
#map {
  position: relative;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 250px;
}

.marker-custom {
  top: 31%;
  left: 45%;
  position: absolute;
  background-image: url("../../public/img/marker.png");
  background-size: cover;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  cursor: pointer;
  z-index: 1;
}

/*.input-search {*/
/*top: 5px;*/
/*right: 5px;*/
/*position: absolute;*/
/*background-size: cover;*/
/*width: auto;*/
/*height: 50px;*/
/*border-radius: 50%;*/
/*cursor: pointer;*/
/*z-index: 1;*/
/*opacity: 95%;*/
/*}*/
</style>
<script>
import mapboxgl from "mapbox-gl";
//import MapApi from '../moduleApi/MapApi'
import MethodService from "../service/MethodService";
import MapboxGeocoder from "@mapbox/mapbox-gl-geocoder";
export default {
  props: {
    value: Object,
    cordinatesValue: Array,
    id: String,
    disabled: Boolean,
  },
  data() {
    return {
      mData: {
        dataDefault: {
          token:
            "pk.eyJ1Ijoic2l0ZW5zYyIsImEiOiJjbDV2dHlja3MwZDdiM2lwOWtqaGJ4dTNnIn0.baIM03zTvYrPzEJZOlDtYw",
          style: "mapbox://styles/mapbox/streets-v11",
          mapDataObject: {
            value: [],
            geoJsonData: {
              type: "",
              geometry: {},
            },
          },
          cordinatesValueProps: [],
        },
      },
      map: null,
    };
  },

  methods: {
    async fn_initMap(map) {
      var _this = this;
      mapboxgl.accessToken = this.mData.dataDefault.token;
      if (MethodService.isUndefined(map)) {
        this.map = new mapboxgl.Map({
          container: _this.fn_isNull(_this.id) ? "map" : _this.id, // container id
          style: _this.mData.dataDefault.style, // stylesheet location
          center: MethodService.isUndefined(_this.cordinatesValue)
            ? [105.75, 21]
            : _this.cordinatesValue, // starting position [lng, lat]
          zoom: 15, // starting zoom
          interactive: !_this.disabled,
        });
      }
      let geocoder = new MapboxGeocoder({
        accessToken: mapboxgl.accessToken,
        marker: null,
        mapboxgl: mapboxgl,
      });

      if (!_this.disabled) {
        this.map.addControl(geocoder);
      }
      this.map.addControl(new mapboxgl.NavigationControl());

      _this.mData.dataDefault.mapDataObject =
        /*await*/ _this.fn_getGeoJsonData(map);
      _this.$emit("update", _this.mData.dataDefault.mapDataObject);
      this.map.on(
        "mouseup",
        /*async*/ function () {
          _this.mData.dataDefault.mapDataObject =
            /*await*/ _this.fn_getGeoJsonData(map);
          _this.$emit("update", _this.mData.dataDefault.mapDataObject);
        }
      );
      this.map.on(
        "moveend",
        /*async*/ function () {
          _this.mData.dataDefault.mapDataObject =
            /*await*/ _this.fn_getGeoJsonData(map);
          _this.$emit("update", _this.mData.dataDefault.mapDataObject);
        }
      );
      this.map.on(
        "wheel",
        /*async*/ function () {
          _this.mData.dataDefault.mapDataObject =
            /*await*/ _this.fn_getGeoJsonData(map);
          _this.$emit("update", _this.mData.dataDefault.mapDataObject);
        }
      );
      this.map.on("load", function () {
        // Listen for the `result` event from the Geocoder
        // `result` event is triggered when a user makes a selection
        //  Add a marker at the result's coordinates
        geocoder.on(
          "result",
          /*async*/ function (e) {
            _this.$emit("selectedSearchItem", { mode: "search" });
            /*let res = await MapApi.searchByLngLat({
              long: e.result.center[0],
              lat: e.result.center[1]
            }, mapboxgl.accessToken);
            let featureLast = res.features.pop();*/
            let result = {
              value: [e.result.center[0], e.result.center[1]],
              /*geoJson: {
                type: featureLast.geometry.type,
                coordinates: res.query
              }*/
            };
            _this.mData.dataDefault.mapDataObject = result;
            _this.$emit("update", _this.mData.dataDefault.mapDataObject);
          }
        );
      });
      _this.mData.mapBox = map;
    },
    fn_isNull(value) {
      return MethodService.isNull(value);
    },

    /*async*/ fn_getGeoJsonData(map) {
      this.$emit("selectedSearchItem", { mode: "none" });
      /*let result = await MapApi.searchByLngLat({
          long: map.getCenter().lng,
          lat: map.getCenter().lat
        }, mapboxgl.accessToken);
        let featureLast = result.features.pop();*/
      return {
        value: [this.map.getCenter().lng, this.map.getCenter().lat],
        /*geoJson: {
            type: featureLast.geometry.type,
            coordinates: result.query
          }*/
      };
    },
  },
  watch: {
    cordinatesValue(newValue) {
      this.map.flyTo({ center: newValue, essential: true });
    },
  },
  created() {},

  mounted: async function () {
    await this.fn_initMap();
  },
};
</script>
